<template>
  <v-card :class="cardBackground">
    <v-toolbar
      class="text-h6 mb-3"
      :class="darkMode ? '' : 'mx-1 mt-1'"
      :style="toolbarLength"
    >
      Select Unit
    </v-toolbar>
    <transition-group
      class="pt-2"
      :class="units.length > 0 ? 'scroll-y' : ''"
      style="max-height: 510px;"
      name="scroll-y-transition"
      tag="div"
    >
      <select-unit-card
        v-for="unit in units"
        v-show="showUnit(unit.pms_ledger_id)"
        :key="unit.pms_ledger_id"
        :unit="unit"
        :class="darkMode ? 'secondary' : 'grey lighten-4'"
      />
    </transition-group>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SelectUnitCard from "@/modules/accounts-receivable/components/SelectUnitCard";

export default {
  name: "PlanUnitSelect",

  components: { SelectUnitCard },

  data() {
    return {};
  },

  methods: {
    showUnit(unitId) {
      if (
        this.selectedPaymentPlan &&
        this.selectedPaymentPlan.ledger_id
      ) {
        return unitId === this.selectedPaymentPlan.ledger_id;
      } else {
        return true;
      }
    }
  },

  computed: {
    ...mapState({
      planCart: state => state.accountsReceivable.planCart,
      darkMode: state => state.application.settings.darkTheme,
      units: state => state.tenant.ledgers
    }),

    ...mapGetters({
      selectedPaymentPlan: "selectedPaymentPlan"
    }),

    cardBackground() {
      return this.darkMode ? "" : "grey lighten-4";
    },

    toolbarLength() {
      return this.darkMode ? "width: 65vw" : "width: 61.6vw";
    }
  }
};
</script>
